<template>
  <div class="resource-list">
    <el-dialog :visible.sync="showVideos"
               :title="$t('historyAlarm.label.uploadVideo')"
               width="460px">
      <!-- <el-table :data="videoList"
                :show-header="false"
                style="width: 100%">
        <el-table-column :label="$t('business.label.videoName')">
          <template slot-scope="scope">
                <div class="resource-name" :title="scope.row.resourceName">{{scope.row.resourceName}}</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('business.label.operation')" width="100px">
          <template slot-scope="scope">
            <el-button type="text"
                       @click="playVideo(scope.row)" class="security icon-bofang2">
            </el-button>
          </template>
        </el-table-column>
      </el-table> -->
    </el-dialog>
  </div>
</template>
<script>
import { setTimeout } from 'timers'
import { Bus } from '$utils'
export default {
  props: ['videoList'],
  data() {
    return {
      Bus,
      showVideos: false,
      showPlayVideo: false,
      currentVideo: ''
    }
  },
  methods: {
    open() {
      this.showVideos = true
    },
    playVideo(item) {
      this.$emit('enlargeResource',item);
    },
    videoClose() {
        let myVideo = document.getElementsByTagName('video')[0];   //获取视频video
        myVideo.pause();
    }
  }
}
</script>
<style>
  .resource-list .resource-name{
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
</style>
